<template>
    <div>
        <cw-modal :id="store.modals.PRICING_TABLE_RAPPORTEN" :title="translate('bedrijfsrapporten')" size="lg">
            <div class="grid grid-cols-3 gap-10 mt-6">
                <div class="flex flex-col gap-5">
                    <div class="font-semibold">Premium</div>
                    <ul class="list">
                        <li>{{translate('modal_rapporten_usp_1')}}</li>
                        <li>{{translate('modal_rapporten_usp_2')}}</li>
                        <li>{{translate('modal_rapporten_usp_3')}}</li>
                    </ul>
                </div>
                <div class="flex flex-col gap-5">
                    <div class="font-semibold">Standard</div>
                    <ul class="list">
                        <li>{{translate('modal_rapporten_usp_1')}}</li>
                        <li>{{translate('modal_rapporten_usp_2')}}</li>
                    </ul>
                </div>
                <div class="flex flex-col gap-5">
                    <div class="font-semibold">Basic</div>
                    <ul class="list">
                        <li>{{translate('modal_rapporten_usp_1')}}</li>
                    </ul>
                </div>
            </div>
            <div class="grid grid-cols-3 gap-10 mt-6">
                <div>
                    <img src="/images-new/pricing/features/report-premium.png" alt="Premium" class="border border-grey-300 rounded-lg overflow-clip"/>
                </div>
                <div>
                    <img src="/images-new/pricing/features/report-standard.png" alt="Premium" class="mt-auto border border-grey-300 rounded-lg overflow-clip"/>
                </div>
                <div>
                    <img src="/images-new/pricing/features/report-basic.png" alt="Premium" class="mt-auto border border-grey-300 rounded-lg overflow-clip"/>
                </div>
            </div>
            <div class="grid grid-cols-3 gap-10 mt-6">
                <div>
                    <a :href="'/'+language+'/sample/report/premium'" target="_blank" class="btn btn-sm btn-ghost">{{translate('sample_report')}}</a>
                </div>
                <div>
                    <a :href="'/'+language+'/sample/report/standard'" target="_blank" class="btn btn-sm btn-ghost">{{translate('sample_report')}}</a>
                </div>
                <div>
                    <a :href="'/'+language+'/sample/report/basic'" target="_blank" class="btn btn-sm btn-ghost">{{translate('sample_report')}}</a>
                </div>
            </div>
        </cw-modal>
        <cw-modal :id="store.modals.PRICING_TABLE_BEDRIJFSLEIDING" :title="translate('bedrijfsleiding')" size="lg">
           <div class="max-h-[70vh] overflow-y-auto">
               <div class="grid grid-cols-3 gap-10 mt-6">
                   <div class="flex flex-col gap-5">
                       <div class="font-semibold">Premium</div>
                       <ul class="list">
                           <li>{{translate('modal_management_usp_1')}}</li>
                           <li>{{translate('modal_management_usp_2')}}</li>
                           <li>{{translate('modal_management_usp_3')}}</li>
                           <li>{{translate('modal_management_usp_4')}}</li>
                       </ul>
                   </div>
                   <div class="flex flex-col gap-5">
                       <div class="font-semibold">Standard</div>
                       <ul class="list">
                           <li>{{translate('modal_management_usp_1')}}</li>
                           <li>{{translate('modal_management_usp_2')}}</li>
                           <li>{{translate('modal_management_usp_3')}}</li>
                       </ul>
                   </div>
                   <div class="flex flex-col gap-5">
                       <div class="font-semibold">Basic</div>
                       <ul class="list">
                           <li>{{translate('modal_management_usp_1')}}</li>
                       </ul>
                   </div>
               </div>
               <div class="grid grid-cols-3 gap-10 mt-6">
                   <div class="space-y-2">
                       <img src="/images-new/pricing/features/mandates_basic.png" alt="Premium" class="border border-grey-300 rounded-lg overflow-clip"/>
                       <img src="/images-new/pricing/features/mandates_premium.png" alt="Premium" class="border border-grey-300 rounded-lg overflow-clip"/>
                       <img src="/images-new/pricing/features/spider-wo-screen.png" alt="Premium" class="border border-grey-300 rounded-lg overflow-clip"/>
                   </div>
                   <div class="space-y-2">
                       <img src="/images-new/pricing/features/mandates_basic.png" alt="Standard" class="border border-grey-300 rounded-lg overflow-clip"/>
                       <img src="/images-new/pricing/features/mandates_standard.png" alt="Standard" class="border border-grey-300 rounded-lg overflow-clip"/>
                       <img src="/images-new/pricing/features/spider-wo-screen.png" alt="Standard" class="border border-grey-300 rounded-lg overflow-clip"/>
                   </div>
                   <div>
                       <img src="/images-new/pricing/features/mandates_basic.png" alt="Basic" class="border border-grey-300 rounded-lg overflow-clip"/>
                   </div>
               </div>
           </div>
        </cw-modal>
        <cw-modal :id="store.modals.PRICING_TABLE_BEDRIJFSINFORMATIE" :title="translate('bedrijfsinformatie')" >
            <ul class="list">
                <li>{{translate('modal_bedrijfsinformatie_usp_1')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_2')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_3')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_4')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_5')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_6')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_7')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_8')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_9')}}</li>
                <li>{{translate('modal_bedrijfsinformatie_usp_10')}}</li>
            </ul>
        </cw-modal>
        <cw-modal :id="store.modals.PRICING_TABLE_MOBILE_APP" :title="translate('mobile_app')" size="lg">
            <div>
                <p class="max-w-lg">{{translate('modal_mobile_usp')}}</p>
                
                <div class="grid grid-cols-4 gap-6 mt-10">
                    <img src="/images-new/pricing/features/mobile4.jpeg" alt="Mobile App" class="border border-grey-400 rounded-2xl">
                    <img src="/images-new/pricing/features/mobile1.jpeg" alt="Mobile App" class="border border-grey-400 rounded-2xl">
                    <img src="/images-new/pricing/features/mobile2.jpeg" alt="Mobile App" class="border border-grey-400 rounded-2xl">
                    <img src="/images-new/pricing/features/mobile3.jpeg" alt="Mobile App" class="border border-grey-400 rounded-2xl">
                </div>
            </div>
        </cw-modal>
        <cw-modal :id="store.modals.PRICING_TABLE_BETALINGSERVARING" :title="translate('betalingservaring')">
            <div>
                <p>
                    {{translate('modal_betalingservaring_usp')}}
                </p>
                <img :src="'/images-new/pricing/features/betalingservaring.' + language + '.png'" alt="Standard" class="mt-6 border border-grey-300 rounded-lg overflow-clip"/>
            </div>
        </cw-modal>
        <cw-modal :id="store.modals.PRICING_TABLE_TIMELINE" :title="translate('tijdslijn')">
            <div>
                <img src="/images-new/pricing/tooltips/nl/tijdlijn.svg" class="w-full mt-8" :alt="translate('tijdslijn')" />
            </div>
        </cw-modal>
        <div class="[&>div]:grid [&>div]:grid-cols-[22rem_1fr_1fr_1fr] 
        [&>div>div]:py-3 
        [&>div>div]:px-6 
        [&>div>div]:flex 
        [&>div>div]:items-center 
        [&>div>div]:border-b 
        [&>div>div]:border-grey-200 
        [&>div]:hover:[&>div]:bg-grey-100 
        [&>div>div:nth-child(2)]:border-x
        [&>div>div:nth-child(2)]:border-x-primary-300">
            <div class="sticky top-0">
                <div class="!bg-white !block"></div>
                <div class="rounded-t-xl !block border-t !bg-white !border-t-primary-300 relative">
                    <span class="absolute right-2 top-2">
                        <span class="rounded-lg bg-primary-100 border border-primary-200 text-primary-500 font-medium py-1 px-2 text-sm">
                            {{translate('meest_gekozen')}}
                        </span>
                    </span>
                    <div class="size-14  -ml-2 box-content flex items-center justify-center">
                        <img src="/images-new/pricing/premium.svg" alt="premium" />
                    </div>
                    <div class="text-lg font-semibold ">Premium</div>
                </div>
                <div class="!bg-white rounded-t-xl !block">
                    <div class="size-14 -ml-2 box-content flex items-center justify-center">
                        <img src="/images-new/pricing/standard.svg" alt="standard" />
                    </div>
                    <div class="text-lg font-semibold ">Standard</div>
                </div>
                <div class="!bg-white rounded-t-xl !block">
                    <div class="size-14 -ml-2 box-content flex items-center justify-center">
                        <img src="/images-new/pricing/basic.svg" alt="basic" />
                    </div>
                    <div class="text-lg font-semibold ">Basic</div>
                </div>
            </div>

            <div>
                <div class="font-medium">{{translate('aantal_gebruikers')}}</div>
                <div>
                    <select v-model="form.users.premium">
                        <option v-for="o in users" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div>
                    <select v-model="form.users.standard">
                        <option v-for="o in users" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div>
                    <span class="text-grey-800">5</span>
                </div>
            </div>

            <div>
                <div class="font-medium">{{translate('opzoekingen_per_week')}}</div>
                <div>
                    <select v-model="form.webhits.premium">
                        <option v-for="o in webhitsPremium" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div>
                    <select v-model="form.webhits.standard">
                        <option v-for="o in webhitsStandard" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div>
                    <span class="text-grey-800">250</span>
                </div>
            </div>

            <div>
                <div class="font-medium">{{translate('bedrijven_in_alerts')}}</div>
                <div>
                 <select v-model="form.alerts.premium">
                     <option v-for="o in alertsPremium" :value="o">{{o.amount}}</option>
                 </select>
                </div>
                <div>
                    <select v-model="form.alerts.standard">
                        <option v-for="o in alertsBasicAndStandard" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div>
                    <span class="text-grey-800">50</span>
                </div>
            </div>

            <div>
                <div class="font-medium">{{translate('bedrijven_in_alerts_plus')}}</div>
                <div>
                    <select v-model="form.alerts_plus.premium">
                        <option v-for="o in alertsPlus" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div></div>
                <div></div>
            </div>
            
            <div>
                <div class="font-medium">{{translate('screening_klantenbestand')}}</div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
                <div>
                    <i class="fas fa-times text-grey-300"></i> 
                </div>
                <div>
                    <i class="fas fa-times text-grey-300"></i> 
                </div>
            </div>

            <div>
                <div>
                    <a class="font-medium underline" href="" @click.prevent="store.openModal(store.modals.PRICING_TABLE_RAPPORTEN)">{{translate('bedrijfsrapporten')}}</a>
                </div>
                <div>
                    <span class="text-grey-800">{{translate('premiumrapporten')}}</span>
                </div>
                <div>
                    <span class="text-grey-800">{{translate('standardrapporten')}}</span>
                </div>
                <div>
                    <span class="text-grey-800">{{translate('basisrapporten')}}</span>
                </div>
            </div>
            
            <div>
                <div class="font-medium">
                    <a class="font-medium underline" href="" @click.prevent="store.openModal(store.modals.PRICING_TABLE_BEDRIJFSINFORMATIE)">{{translate('bedrijfsinformatie')}}</a>
                </div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
            </div>
            
            <div>
                <div class="font-medium">
                    <a class="font-medium underline" href="" @click.prevent="store.openModal(store.modals.PRICING_TABLE_BEDRIJFSLEIDING)">{{translate('bedrijsleiding')}}</a>
                </div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
            </div>

            <div>
                <div class="font-medium">
                    <a class="font-medium underline" href="" @click.prevent="store.openModal(store.modals.PRICING_TABLE_BETALINGSERVARING)">{{translate('betalingservaring')}}</a>
                </div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
                <div>
                    <i class="fas fa-check text-primary-400"></i>
                </div>
            </div>


            <div>
                <div class="font-medium">{{translate('zoeken_op_bedrijf')}}</div>
                <div><i class="fas fa-check text-primary-400"></i> </div>
                <div><i class="fas fa-check text-primary-400"></i></div>
                <div><i class="fas fa-check text-primary-400"></i></div>
            </div>
            
            <div>
                <div class="font-medium">{{translate('zoeken_op_bedrijfsleider')}}</div>
                <div><i class="fas fa-check text-primary-400"></i> </div>
                <div><i class="fas fa-check text-primary-400"></i></div>
                <div><i class="fas fa-times text-grey-300"></i> </div>
            </div>
            
            <div>
                <div class="font-medium">{{translate('zoeken_op_adres')}}</div>
                <div><i class="fas fa-check text-primary-400"></i> </div>
                <div><i class="fas fa-times text-grey-300"></i> </div>
                <div><i class="fas fa-times text-grey-300"></i> </div>
            </div>
            
            <div>
                <div class="font-medium">
                    <a class="font-medium underline" href="" @click.prevent="store.openModal(store.modals.PRICING_TABLE_TIMELINE)">{{translate('tijdslijn')}}</a>
                </div>
                <div><i class="fas fa-check text-primary-400"></i> </div>
                <div><i class="fas fa-times text-grey-300"></i></div>
                <div><i class="fas fa-times text-grey-300"></i></div>
            </div>

            <div>
                <div class="font-medium">
                    <a class="font-medium underline" href="" @click.prevent="store.openModal(store.modals.PRICING_TABLE_MOBILE_APP)">{{translate('mobile_app')}}</a>
                </div>
                <div>
                    <select v-model="form.mobile_app.premium">
                        <option v-for="o in mobiles" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div><i class="fas fa-times text-grey-300"></i></div>
                <div><i class="fas fa-times text-grey-300"></i></div>
            </div>
    
            <div>
                <div class="font-medium">{{translate('internationale_rapporten')}}</div>
                <div>
                    <select v-model="form.international_reports.premium">
                        <option v-for="o in internationalReports" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div>   
                    <select v-model="form.international_reports.standard">
                        <option v-for="o in internationalReports" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div><i class="fas fa-times text-grey-300"></i></div>
            </div>
            
            <div>
                <div class="font-medium">{{translate('add_ayce_nl')}}</div>
                <div>
                    <input type="checkbox" v-model="includeNl">
                </div>
                <div><i class="fas fa-times text-grey-300"></i></div>
                <div><i class="fas fa-times text-grey-300"></i></div>
            </div>
            
            <div>
                <div class="font-medium">{{translate('add_ayce_lu')}}</div>
                <div>
                    <input type="checkbox" v-model="includeLu">
                </div>
                <div><i class="fas fa-times text-grey-300"></i></div>
                <div><i class="fas fa-times text-grey-300"></i></div>
            </div>

            <div>
                <div class="font-medium">{{translate('add_ayce_fr')}}</div>
                <div>
                    <input type="checkbox" v-model="includeFr">
                </div>
                <div><i class="fas fa-times text-grey-300"></i></div>
                <div><i class="fas fa-times text-grey-300"></i></div>
            </div>

            <div>
                <div class="font-medium">{{translate('internationale_alerts_nl_fr')}}</div>
                <div>
                    <select v-model="form.alerts_international.premium">
                        <option v-for="o in alertsInternational" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div><i class="fas fa-times text-grey-300"></i></div>
                <div><i class="fas fa-times text-grey-300"></i></div>
            </div>

            <div>
                <div class="font-medium">KYC: {{translate('pep_en_sanctiechecks')}}</div>
                <div>
                    <select v-model="form.pep_checks.premium">
                        <option v-for="o in pepChecks" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div>
                    <select v-model="form.pep_checks.standard">
                        <option v-for="o in pepChecks" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div><i class="fas fa-times text-grey-300"></i></div>
            </div>
            
            <div>
                <div class="font-medium">{{translate('prospectie_en_eigen_data_verrijken')}}</div>
                <div>
                    <select v-model="form.dm_credits.premium">
                        <option v-for="o in dmCredits" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div>
                    <select v-model="form.dm_credits.standard">
                        <option v-for="o in dmCredits" :value="o">{{o.amount}}</option>
                    </select>
                </div>
                <div><i class="fas fa-times text-grey-300"></i></div>
            </div>

            <div>
                <div class="font-medium">{{translate('integratie')}}</div>
                <div>
                    <software-picker :key="1" v-model="chosenPremiumIntegration" hide-intro modal-name="PRICING_INTEGRATIONS_PREMIUM"></software-picker>
                </div>
                <div>
                    <software-picker :key="1" v-model="chosenStandardIntegration" hide-intro modal-name="PRICING_INTEGRATIONS_STANDARD"></software-picker>
                </div>
                <div><i class="fas fa-times text-grey-300"></i></div>
            </div>
    
            <div>
                <div class="!pt-12 !border-b-0 text-lg font-semibold sticky top-14 bg-white">{{translate('totaalprijs')}}</div>
                <div class="!pt-12 !border-b-primary-300 font-semibold text-lg rounded-b-lg !block">
                    € {{getPackagePrice(PackageType.PREMIUM).formatThousandSeparator()}}
                    <span class="text-sm text-grey-800 font-normal ml-2">{{translate('per_jaar')}}</span>
                    <div class="text-grey-800 text-sm font-normal mt-2" v-if="chosenPremiumIntegration">+ {{translate('integratiekost')}} {{chosenPremiumIntegration.name}}</div>
                </div>
                <div class="!pt-12 !border-b-0 font-semibold text-lg !block">
                    € {{getPackagePrice(PackageType.STANDARD).formatThousandSeparator()}}
                    <span class="text-sm text-grey-800 font-normal ml-2">{{translate('per_jaar')}}</span>
                    <div class="text-grey-800 text-sm font-normal mt-2" v-if="chosenStandardIntegration">+ {{translate('integratiekost')}} {{chosenStandardIntegration.name}}</div>
                </div>
                <div class="!pt-12 !border-b-0 font-semibold text-lg">
                    € {{getPackagePrice(PackageType.BASIC).formatThousandSeparator()}}
                    <span class="text-sm text-grey-800 font-normal ml-2">{{translate('per_jaar')}}</span>
                </div>
            </div>
        </div>
        <div class="mt-12">
            <span class="alert info">
                {{translate('excl_vat_message')}}
            </span>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {Language} from "../../../../types/dto/Language";
import {Package, PackageType} from "../../types";
import SoftwarePicker, {Integration} from "../../../../components/software-picker.vue";
import {useStore as useCheckoutStore} from "../../store";

interface PricingOption {
    amount: number;
    price: number;
}

enum LijnNaam {
    USERS = "users",
    WEBHITS = "webhits",
    ALERTS = "alerts",
    ALERTS_PLUS = "alerts_plus",
    MOBILE_APP = "mobile_app",
    INTERNATIONAL_REPORTS = "international_reports",
    ALERTS_INTERNATIONAL = "alerts_international",
    PEP_CHECKS = "pep_checks",
    DM_CREDITS = "dm_credits",
    INCLUDE_NL = "include_nl",
}

type Config = Record<LijnNaam, {[PackageType.PREMIUM]: PricingOption, [PackageType.STANDARD]: PricingOption, [PackageType.BASIC]: PricingOption}>;

export default defineComponent({
    name: "sales-pricing-table",
    components: {
        SoftwarePicker
    },
    props: {
        language: String as () => Language
    },
    data() {
        const packages = window.cw.packages as Package[];
        const users = window.cw.pricing.users as PricingOption[];
        const webhitsPremium = window.cw.pricing.webhitsPremium as PricingOption[];
        const webhitsStandard = window.cw.pricing.webhitsStandard as PricingOption[];
        const alertsBasicAndStandard = window.cw.pricing.alertsBasicAndStandard as PricingOption[];
        const alertsPremium = window.cw.pricing.alertsPremium as PricingOption[];
        const alertsPlus = window.cw.pricing.alertsPlus as PricingOption[];
        const alertsInternational = window.cw.pricing.alertsInternational as PricingOption[];
        const mobiles = window.cw.pricing.mobiles as PricingOption[];
        const internationalReports = window.cw.pricing.internationalReports as PricingOption[];
        const pepChecks = window.cw.pricing.pepChecks as PricingOption[];
        const dmCredits = window.cw.pricing.dmCredits as PricingOption[];
        
        return {
            checkoutStore: useCheckoutStore(),
            chosenPremiumIntegration: null as Integration | null,
            chosenStandardIntegration: null as Integration | null,
            includeNl: false,
            includeLu: false,
            includeFr: false,
            PackageType,
            form: {
                [LijnNaam.USERS]: {
                    premium: users[0],
                    standard: users[0],
                    basic: users[0]
                },
                [LijnNaam.ALERTS]: {
                    premium: alertsPremium[0],
                    standard: alertsBasicAndStandard[0],
                    basic: alertsBasicAndStandard[0]
                },
                [LijnNaam.WEBHITS]: {
                    premium: webhitsPremium[0],
                    standard: webhitsStandard[0],
                    basic: webhitsStandard[0]
                },
                [LijnNaam.ALERTS_PLUS]: {
                    premium: alertsPlus[0],
                    standard: alertsPlus[0],
                    basic: alertsPlus[0]
                },
                [LijnNaam.MOBILE_APP]: {
                    premium: mobiles[0],
                    standard: mobiles[0],
                    basic: mobiles[0]
                },
                [LijnNaam.INTERNATIONAL_REPORTS]: {
                    premium: internationalReports[0],
                    standard: internationalReports[0],
                    basic: internationalReports[0]
                },
                [LijnNaam.ALERTS_INTERNATIONAL]: {
                    premium: alertsInternational[0],
                    standard: alertsInternational[0],
                    basic: alertsInternational[0]
                },
                [LijnNaam.PEP_CHECKS]: {
                    premium: pepChecks[0],
                    standard: pepChecks[0],
                    basic: pepChecks[0]
                },
                [LijnNaam.DM_CREDITS]: {
                    premium: dmCredits[0],
                    standard: dmCredits[0],
                    basic: dmCredits[0]
                }
            } as Config,
            users,
            webhitsPremium,
            webhitsStandard,
            alertsBasicAndStandard,
            alertsPremium,
            alertsPlus,
            alertsInternational,
            mobiles,
            internationalReports,
            pepChecks,
            dmCredits,
            packages
        }
    },
    methods: {
      getPackagePrice(pack: PackageType.BASIC | PackageType.STANDARD | PackageType.PREMIUM): number {
          const extraCountryPrice = this.checkoutStore.extraCountryPrice;
          const basePrice = this.packages.find(p => p.abonnement.abonnement === pack)?.abonnement.price ?? 0;
          const featurePrice = Object.values(this.form).reduce((price, config) => {
              return price + config[pack].price;
          }, 0);
          const ayceNlPrice = (this.includeNl && pack === PackageType.PREMIUM) ? extraCountryPrice : 0;
          const ayceLuPrice = (this.includeLu && pack === PackageType.PREMIUM) ? extraCountryPrice : 0;
          const ayceFrPrice = (this.includeFr && pack === PackageType.PREMIUM) ? extraCountryPrice : 0;
          
          return basePrice + featurePrice + ayceNlPrice + ayceLuPrice + ayceFrPrice;
      }
    },
});
</script>